module.exports = {
  API_URL:process.env.REACT_APP_API_URL,
  REACT_APP_ASSETURL:process.env.REACT_APP_ASSETURL,
  REACT_APP_WHATSAPP_URL:process.env.REACT_APP_WHATSAPP_URL,
  REACT_APP_SMS_URL:process.env.REACT_APP_SMS_URL,
  REACT_APP_TEST_PASS:process.env.REACT_APP_TEST_PASS,
  REACT_APP_LINK_URL:process.env.REACT_APP_LINK_URL,
  REACT_APP_ADMINID:process.env.REACT_APP_ADMINID

}
